// The partner logos the home page ships with. They stand until somebody saves a list from
// /partners-admin, and are what the band falls back to if that API cannot be reached - so the
// foot of the page is never empty.
export const PARTNERS_DEFAULT = [
  { name: 'vACC Hungary', image: '/images/partners/vacc-hun.png', href: 'https://vacchun.hu/' },
  { name: 'simref', image: '/images/partners/simref.png', href: 'https://ezy887.ch/' },
  { name: 'VATSIM', image: '/images/partners/vatsim1.png', href: 'https://vatsim.net' },
  { name: 'iniBuilds', image: '/images/partners/inibuilds.png', href: 'https://inibuilds.com' },
  { name: 'vACC Slovakia', image: '/images/partners/slovakia.png', href: 'https://vacc-slovakia.sk/' },
  { name: 'IVAO Partner VA', image: '/images/partners/ivao-partner-v.png', href: 'https://xu.ivao.aero/' },
];

export default PARTNERS_DEFAULT;
